import $ from 'jquery'

import colors from '../../../../../lib/colors'

import { button } from '../../../../../component/component'

export default function(o,parent){

  var set = function(modelId){
    contributorsDiv.setColor(modelId == 'contributors' ? colors.yellow.s_600 : colors.white)
    contributorsDiv.setDisabled(modelId == 'contributors')
    rollsDiv.setDisabled(modelId == 'rollsData')
    rollsDiv.setColor(modelId == 'rollsData' ? colors.yellow.s_600 : colors.white)
    aMarkersDiv.setDisabled(modelId == 'aMarkers')
    aMarkersDiv.setColor(modelId == 'aMarkers' ? colors.yellow.s_600 : colors.white)
    aaMarkersDiv.setDisabled(modelId == 'aaMarkers')
    aaMarkersDiv.setColor(modelId == 'aaMarkers' ? colors.yellow.s_600 : colors.white)
    userMarkersDiv.setColor(modelId == 'userMarkers' ? colors.yellow.s_600 : colors.white)
    aTagsDiv.setDisabled(modelId == 'aTags')
    aTagsDiv.setColor(modelId == 'aTags' ? colors.yellow.s_600 : colors.white)
    aaTagsDiv.setDisabled(modelId == 'aaTags')
    aaTagsDiv.setColor(modelId == 'aaTags' ? colors.yellow.s_600 : colors.white)
    aMoviesDiv.setDisabled(modelId == 'aMovies')
    aMoviesDiv.setColor(modelId == 'aMovies' ? colors.yellow.s_600 : colors.white)
    usersDiv.setDisabled(modelId == 'aUsers')
    usersDiv.setColor(modelId == 'aUsers' ? colors.yellow.s_600 : colors.white)
    newsAddressDiv.setDisabled(modelId == 'newsAddress')
    newsAddressDiv.setColor(modelId == 'newsAddress' ? colors.yellow.s_600 : colors.white)
    contentDiv.setDisabled(modelId == 'content')
    contentDiv.setColor(modelId == 'content' ? colors.yellow.s_600 : colors.white)
    userLogsDiv.setDisabled(modelId == 'aUserLogs')
    userLogsDiv.setColor(modelId == 'aUserLogs' ? colors.yellow.s_600 : colors.white)
  }

  var rollsDiv =
    button('ROLLS','custom-roll')
    .click(function(e){
      parent.set('rollsData')
    })

  var contributorsDiv =
    button('CONTRIBUTORS','fi-torso')
    .click(function(e){
      parent.set('contributors')
    })

  var aMarkersDiv =
    button('MARKERS','custom-marker')
    .click(function(e){
      parent.set('aMarkers')
    })

  var aaMarkersDiv =
    button('ANTI-MARKERS','custom-marker')
    .click(function(e){
      parent.set('aaMarkers')
    })

  var userMarkersDiv =
    button('USER-MARKERS','custom-marker')
    .click(function(e){
      parent.set('userMarkers')
    })

  var aTagsDiv =
    button('TAGS','fi-price-tag')
    .click(function(e){
      parent.set('aTags')
    })

  var aaTagsDiv =
    button('ANTI-TAGS','fi-price-tag')
    .click(function(e){
      parent.set('aaTags')
    })

  var aMoviesDiv =
    button('MOVIES','custom-roll')
    .click(function(e){
      parent.set('aMovies')
    })

  var usersDiv =
    button('USERS','fi-torso')
    .click(function(e){
      parent.set('aUsers')
    })

  var newsAddressDiv =
    button('NEWS','fi-mail')
    .click(function(e){
      parent.set('newsAddress')
    })

  var contentDiv =
    button('WEBSITE','fi-page')
    .click(function(e){
      parent.set('content')
    })

  var userLogsDiv =
    button('USERLOGS','fi-list-thumbnails')
    .click(function(e){
      parent.set('aUserLogs')
    })

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '34px',
      overflowY: 'auto',
    })

  if(o.store('role') == "admin"){
    div.append([
      contributorsDiv,
    ])
  }

  div.append([
    rollsDiv,
  ])

  if(o.store('role') == "admin" || o.store('role') == "author"){
    div.append([
      aTagsDiv,
    ])
  }

  div.append([
    aMarkersDiv,
  ])

  if(o.store('role') == "admin" || o.store('role') == "author"){
    div.append([
      aaTagsDiv,
    ])
  }

  if(o.store('role') == "admin" || o.store('role') == "author"){
    div.append([
      aaMarkersDiv,
    ])
  }

  div.append([
    userMarkersDiv,
  ])

  if(o.store('role') == "admin" || o.store('role') == "author"){
    div.append([
      aMoviesDiv,
    ])
  }

  if(o.store('role') == "admin"){
    div.append([
      contentDiv,
    ])
  }

  if(o.store('role') == "admin"){
    div.append([
      usersDiv,
      newsAddressDiv,
    ])
  }

  if(o.store('role') == "admin"){
    div.append([
      userLogsDiv,
    ])
  }

  div.set = set

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/tabs/main/main.js